import React, { Component } from 'react';
import { connect } from 'react-redux';

// Packages
import Emoji from 'react-emoji-render';
import { Helmet } from 'react-helmet';

// API
import * as API  from '../../../utils/api';

// Components
import FormInput from '../../../components/Global/Forms/FormInput';
import RadioFormInput from '../../../components/Global/Forms/RadioFormInput';
import FlashMessage from '../../../components/Global/FlashMessage';

// Actions
import {
  updateUserState,
} from '../../../actions/user'


class ConnectProfile extends Component {

  state = {
    input: {
      athlete_has_account: '0',
      username: '',
    },
    radioOptions: [
      {value: '0', label: 'Yes'},
      {value: '1', label: 'No'},
    ],
    formErrors: {
      athlete_has_account: '',
      username: '',
    },
    formIsValid: false,
    displayErrorMessages: false,
    displayMaintainerRequestSuccessMessage: false,
  }

  componentDidMount() {
    this.props.updateReduxUser({
      isOnboarding: true
    })
  }

  handleInputChange = (event) => {
    const { value, name } = event.target;

    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        [name]: value
      }
    }), () => { this.updateFieldErrorMessage(name, value) });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const { athlete_has_account, username } = this.state.input;

    if (athlete_has_account === '1') {
      this.props.handleFormChange('athlete-info', 'connect-profile');
    }

    if (this.isFormValid()) {
      API.requestMaintainerAccess(this.props.user, username)
        .then(response => {
          if (response.errors) {
            this.setUsernameErrorMessage(response.errors);
          } else {
            this.displayMaintainerRequestSuccessMessage();
          }
        })

        this.displayMaintainerRequestSuccessMessage();

    } else {
      this.setFormErrorState();
    }
  }

  displayMaintainerRequestSuccessMessage() {
    this.setState(state => ({
      ...state,
      displayMaintainerRequestSuccessMessage: true
    }));
  }

  setFormErrorState = () => {
    const { input, displayErrorMessages } = this.state;

    Object.keys(input).map((field, i) => {
      return this.updateFieldErrorMessage(field, input[field])
    })

    if (!this.state.formIsValid && !displayErrorMessages) {
      this.toggleErrorMessages();
    }
  }

  turnOnErrorMessages() {
    this.setState(state => ({
      ...state,
      displayErrorMessages: true
    }));
  }

  toggleErrorMessages() {
    const { displayErrorMessages } = this.state;

    this.setState(state => ({
      ...state,
      displayErrorMessages: !displayErrorMessages
    }));
  }

  isFormValid() {
    const { input } = this.state;

    let inputErrorIndex = Object.keys(input).map((field, i) => {
      return this.isFieldValid(field, input[field])
    }).indexOf(false)

    if (inputErrorIndex > -1) {
      return false;
    } else {
      return true;
    }
  }

  isFieldValid = (fieldName, value) => {
    switch(fieldName) {
      default:
        return value.length > 0
        // eslint-disable-next-line no-unreachable
        break;
    }
  }

  updateFieldErrorMessage = (fieldName, value) => {
    let formErrors = this.state.formErrors;

    switch(fieldName) {
      default:
        formErrors[fieldName] = value.length > 0
          ? ''
          : 'Please complete this field';
        break;
    }

    this.setState(state => ({
      ...state,
      formErrors,
    }));
  }

  setUsernameErrorMessage = (errorMessage) => {
    this.setState(state => ({
      ...state,
      formErrors: {
        ...state.formErrors,
        username: errorMessage === 'Not found' ? 'This username does not exist. Please try again.' : 'There was a problem, Please try again.'
      }
    }), () => this.turnOnErrorMessages());
  }

  renderHeaderMessage() {
    const { user, viaLogin } = this.props;
    const { displayMaintainerRequestSuccessMessage } = this.state;

    if (displayMaintainerRequestSuccessMessage) {
      return '';
    } else {
      return viaLogin
      ? (
        <p>
          Welcome back {user.first_name}! In order to finish getting you on board, we need to ask you a couple of questions.
        </p>
      )
      : (
        <p>
          Hi {user.first_name}, welcome to Locker Linked. In order to direct you to the right place we need to ask you a couple questions.
        </p>
      )
    }
  }

  renderForm() {
    const {
      input,
      formErrors,
      displayErrorMessages,
      radioOptions,
      displayMaintainerRequestSuccessMessage
    } = this.state;

    return displayMaintainerRequestSuccessMessage
    ? ''
    : (
      <form onSubmit={this.handleSubmit}>
        <RadioFormInput
          label="Does the athlete you want to manage already have an account?"
          name="athlete_has_account"
          selectedOption={input.athlete_has_account}
          showError={displayErrorMessages}
          errorMessage={formErrors.athlete_has_account}
          onChange={this.handleInputChange}
          options={radioOptions}
          optionalClasses="radio-containers-half"
        />
        {this.renderFormContent()}
        <hr />
        <input
          type="submit"
          onClick={this.handleSubmit}
          value={input.athlete_has_account === '0' ? 'Submit' : 'Continue'}
        />
      </form>
    )
  }

  renderFormContent() {
    const {
      input,
      formErrors,
      displayErrorMessages,
    } = this.state;

    return input.athlete_has_account === '0' ?
    (
      <div className="connect-profile-content">
        <FormInput
          label="Username of Profile"
          placeholder="Enter Username"
          name="username"
          type="text"
          value={input.username}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.username}
        />
        <p>
          After you submit this form, we will ask for your child’s permission to add you as an administrator. Or your child can add you as an administrator by following these instructions:
        </p>
        <ol>
          <li>
            Log in to his/her Locker Linked account.
          </li>
          <li>
            Under Account, select Account Admins.
          </li>
          <li>
            Add parent’s email address to the list of Account Admins, then click Save Changes.
          </li>
          <li>
            Follow the instructions in the email you receive to complete the process.
          </li>
        </ol>
        <p>
          Once submitted, you should receive an email with a link to complete the signup process. If you have more than one child with a Locker Linked account, each must add you as an administrator from his/her account.
        </p>
      </div>
    )
    : (
      <div className="connect-profile-content">
        <p>
          By selecting no you will be setting up your child's account for them. You will have the ability to add your child to the account at a later time.
        </p>
      </div>
    )
  }

  renderMaintainerRequestSuccessMessage() {
    const { displayMaintainerRequestSuccessMessage } = this.state;

    return displayMaintainerRequestSuccessMessage
    ? (
      <FlashMessage optionalClasses="success-message">
        A request to manage your athlete's profile has been sent. Look out for an email when they accept your request.
      </FlashMessage>
    ) : ''
  }

  renderAccountCreationSuccessMessage() {
    const { viaLogin } = this.props;
    const { displayMaintainerRequestSuccessMessage } = this.state;

    if (!displayMaintainerRequestSuccessMessage && viaLogin !== true) {
      return (
        <FlashMessage>
          <Emoji text=":trophy: Your account was successfully created!" />
        </FlashMessage>
      )
    } else {
      return ''
    }
  }

  render() {
    const { appName } = this.props;

    return (
      <div className="onboarding-connect-profile">
        <Helmet>
          <title>{appName} | Connect or Create a Profile</title>
        </Helmet>
        {this.renderAccountCreationSuccessMessage()}
        <header>
          <h2>Connect or Create a Profile</h2>
          {this.renderHeaderMessage()}
        </header>
        {this.renderForm()}
        {this.renderMaintainerRequestSuccessMessage()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    onboarding: state.onboarding
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateReduxUser: user => {
      dispatch(updateUserState(user))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectProfile)



// WEBPACK FOOTER //
// ./src/screens/Onboarding/Forms/ConnectProfile.js